// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DeleteMbOutlinedSvg from "@fishx/icons-svg/es/asn/DeleteMbOutlined";
import FishxIcon from '../components/FishxIcon';

var DeleteMbOutlined = function DeleteMbOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DeleteMbOutlinedSvg
  }));
};

DeleteMbOutlined.displayName = 'DeleteMbOutlined';
export default React.forwardRef(DeleteMbOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DeleteMbOutlined.js
// module id = 2394
// module chunks = 0